export enum MailchimpInterest {
  VENDER = 'VENDER',
  COMPRAR = 'COMPRAR',
  TRABAJAR = 'TRABAJAR',
  OTROS = 'OTROS',
}

export const getInterests = () =>
  Array.from(new Set(Object.values(MailchimpInterest)));
